exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amount[data-v-2971d8ca] {\n  margin-left: 15px;\n}\n.suggestionButton[data-v-2971d8ca] {\n  text-align: center;\n  margin-bottom: 15px;\n}\n.suggestion-box-ppm[data-v-2971d8ca] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 20px;\n  margin: auto;\n}\n.suggestionProducts[data-v-2971d8ca] {\n  margin-left: 4%;\n  margin-right: 4%;\n}\n", ""]);

// exports
